import React from 'react';
import Skeleton from '../../components/skeleton/List';
import '../../assets/css/list.scss';
import Refresh_icon from '../../assets/img/refresh.svg';
import ErrorHandler from '../../class/ErrorHandler';
import PinIcon from '../../assets/img/list/pin';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import constants from '../../lib/constants/constants';
import Refresh from '../../components/Refresh';

class DemoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      shopList: null,
      refresh: false
    };
    this.errorHandler = new ErrorHandler(this);
    this.getShopList = this.getShopList.bind(this);
  }

  componentDidMount() {
    cookie.save('demo', true, { path: '/' });
    cookie.remove('familyId', { path: '/' });
    this.props.setUserName('demo');
    setTimeout(() => {
      this.getShopList();
    }, 1000);
  }

  componentDidUpdate() {
    if (this.props.isRefresh) {
      this.setState({ refresh: true });
      setTimeout(() => {
        this.getShopList();
      }, 1000);
      this.props.setIsRefresh(false);
    }
  }

  getShopList() {
    // 샵리스트 get
    // 샵리스트 리스트 직접 만들기
    let shopList = [
      {
        name: '우리 집',
        familyId: '0000001'
      },
      {
        name: '카페',
        familyId: '0000002'
      }
    ];
    this.setState({ loading: false, shopList: shopList, refresh: false });
  }

  moveDashboard(familyId, familyName) {
    cookie.save('familyId', familyId, { path: '/' });
    cookie.save('familyName', familyName, { path: '/' });
    window.location.href = constants.URL.DEMODASHBOARD;
  }

  render() {
    let shopList = this.state.shopList;
    return (
      <div id="shop-list" className="page">
        {this.state.loading ? (
          <Skeleton />
        ) : this.state.shopList && this.state.shopList.length > 0 ? (
          // 리스트
          <div className="wrap">
            <h2>안녕하세요 {this.props.userName}님</h2>
            <p>헤이홈 for Web 데모에 오신것을 환영해요 :)</p>
            <ul>
              {shopList &&
                shopList.length > 0 &&
                shopList.map(v => {
                  return (
                    <li
                      key={v.familyId}
                      onClick={() => this.moveDashboard(v.familyId, v.name)}
                    >
                      <button className="middle">
                        <div>
                          <PinIcon />
                          <span>{v.name}</span>
                        </div>
                      </button>
                    </li>
                  );
                })}
            </ul>
            {/* 새로고침 */}
            {this.state.refresh && <Refresh />}
          </div>
        ) : (
          // 에러
          <div className="refresh-box">
            <img src={Refresh_icon} alt="refreshIcon" />
            <p>
              <strong>샵 정보를 가져오지 못했어요.</strong>
              <br />
              네트워크 연결 상태를 확인하여 주시거나 헤이홈 앱에서
              <br />
              장소를 생성한 후 새로고침 해주세요.
            </p>
            <button className="btn active" onClick={() => this.getShopList()}>
              새로고침
            </button>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userName: state.hejhome.userName,
    isRefresh: state.hejhome.isRefresh
  };
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
  setUserName: name =>
    dispatch({
      type: 'setUserName',
      userName: name
    }),
  setIsRefresh: bool =>
    dispatch({
      type: 'setIsRefresh',
      isRefresh: bool
    })
});

DemoList = connect(mapStateToProps, mapDispatchToProps)(DemoList);

export default DemoList;
